import React from 'react';
import { Wrapper } from './styles';
import { TitleHeader } from 'components/commons/Template/style';
import { FormattedMessage } from 'react-intl';
import Header from '../components/Header';
import Grid from '../components/Grid';

const PracticeReportPage = () => {
  return (
    <Wrapper id="wrapperReportManager">
      <TitleHeader>
        <FormattedMessage id="layout.leftMenu.practiceReport" />
      </TitleHeader>
      <Header />
      <Grid />
    </Wrapper>
  );
};

export default PracticeReportPage;
